import {ContentBlock, genKey} from "draft-js";

export function createBlock(blockTypeId = "unstyled", text = " ") {
    return new ContentBlock({
        key: genKey(),
        text,
        type: blockTypeId,
    });
}